import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import {
  BciImprintComponent,
  BciSidebarService,
  LogoutComponent,
  NavigationService,
  SidebarNavItem
} from '@bci-web-core/core';
import { TranslateService } from '@ngx-translate/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable, of } from 'rxjs';
import { AuthUserInfo } from 'src/app/models';
import { CommonService, SiteService } from 'src/app/services';
import { AppConfigService } from 'src/app/services/app-config.service';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';
import { AlertService, AuthGuard, Constants } from 'src/app/shared';
import { ContactUsModalComponent } from '../contact-us-modal/contact-us-modal.component';
import { SystemPrivacyModalComponent } from '../system-privacy-modal/system-privacy-modal.component';

@Component({
  selector: 'app-post-login',
  templateUrl: './post-login.component.html',
  styleUrls: ['./post-login.component.scss']
})
export class PostLoginComponent implements OnInit {
  public sidebarFooterLinks: SidebarNavItem[];
  lang: string;
  langFooter: any;
  footerTitle: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public auth: AuthGuard,
    private authService: AuthService,
    private oauthService: OAuthService,
    private dialog: MatDialog,
    private commonService: CommonService,
    private alertService: AlertService,
    private siteService: SiteService,
    private dataService: DataService,
    private translate: TranslateService,
    private sidebarService: BciSidebarService,
    public appConfig: AppConfigService,
    private navigationService: NavigationService
  ) {
    this.translate.stream('sidebar.subStream.footer').subscribe((sub: any) => {
      this.langFooter = sub;
      this.sidebarFooterLinks = [
        {
          title: 'Logout',
          overlay: {
            component: LogoutComponent,
            config: {
              title: 'Do you want to logout?',
              onLogout: () => this.logout()
            }
          },
          icon: 'Bosch-Ic-user'
        },
        {
          id: 'imprint',
          title: 'Legal',
          icon: 'Bosch-Ic-information',
          items: [
            {
              id: 'usagePolicy',
              title: 'Usage Policy',
              cb: () => this.onPolicy()
            },
            {
              id: 'Copyright',
              title: 'Copyright Information',
              cb: () => this.onAbout()
            }
          ]
        },
        {
          title: 'Contact Us',
          cb: () => this.onContact(),
          icon: 'Bosch-Ic-server'
        }
      ];
      // });

      let tokenKeyFromUrl = localStorage.getItem('id_token')
      // this.route.queryParamMap.subscribe((params) => {
      //   tokenKeyFromUrl = params.get('id'); //Get the token from Query params
      // });

      if (
        tokenKeyFromUrl === 'null' ||
        tokenKeyFromUrl === 'Null' ||
        tokenKeyFromUrl === 'NULL'
      ) {
        this.alertService.message = Constants.MESSAGE.Token_Expired;
        this.alertService.showError();
        setTimeout(() => {
          this.authService.logout();
        }, 5000);
      } else if (tokenKeyFromUrl === undefined || tokenKeyFromUrl === '') {
        // if (this.authenticated) {
        //   setTimeout(() => {
        //     this.router.navigate(['/']);
        //   }, 5000);
        // } else {
        setTimeout(() => {
          this.redirectToDaimler();
        }, 5000); // Redirecting to login
        // }
      } else if (
        tokenKeyFromUrl &&
        tokenKeyFromUrl.length > 0 &&
        tokenKeyFromUrl !== 'null'
      ) {
        localStorage.setItem('access_token', tokenKeyFromUrl);
        this.redirectToSiteMasterPage(tokenKeyFromUrl);
      }
    });
  }

  ngOnInit(): void {
    this.lang = localStorage.getItem('lang') || 'en';
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.getSidebarLinks(currentUser, this.lang).subscribe(
      (sidebarLinks) => (this.auth.sidebarLinks = sidebarLinks)
    );
  }

  getSidebarLinks(currentUser, lang): Observable<SidebarNavItem[]> {
    // const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.commonService.isNullOrUndefined(currentUser)) {
      return this.navigationService.getNavigationItems();
    } else {
      this.authService.userActivities = currentUser.activities;
      this.authService.userRole = currentUser.role.name;

      this.authService.userMenus = currentUser.menuItems;
      const menu = [];
      const sidebarLinksUser: SidebarNavItem[] = this.authService.buildMenus(
        this.authService.defaultMenus,
        menu,
        true,
        lang
      );

      this.footerTitle =
        currentUser.fullName !== ''
          ? currentUser.fullName
          : currentUser.userName;
      return of(sidebarLinksUser);
    }
  }

  redirectToSiteMasterPage(token) {
    this.authService.getUserDetail().subscribe((userInfo) => {
      if (userInfo !== null) {
        let fullName = '';

        const firstName = !this.commonService.isNullOrUndefined(
          userInfo.data.firstName
        )
          ? userInfo.data.firstName
          : '';
        const lastName = !this.commonService.isNullOrUndefined(
          userInfo.data.lastName
        )
          ? userInfo.data.lastName
          : '';
        if (firstName !== '' && lastName !== '') {
          fullName = firstName + ' ' + lastName;
        }

        const authUser = new AuthUserInfo(
          token,
          '',
          '',
          userInfo.data.username,
          fullName,
          userInfo.data.role,
          userInfo.data.flatMenus,
          0,
          userInfo.data.useSSO,
          userInfo.data.alreadyLoggedIn,
          userInfo.data.activities
        );
        localStorage.setItem('currentUser', JSON.stringify(authUser));
        this.authService.userActivities = userInfo.data.activities;
        this.authService.userRole = userInfo.data.role.name;
        this.authService.userMenus = userInfo.data.flatMenus;
        const menu = [];
        const sidebarLinksUser: SidebarNavItem[] = this.authService.buildMenus(
          this.authService.defaultMenus,
          menu,
          true,
          this.lang
        );

        this.auth.sidebarLinks = sidebarLinksUser;
        this.sidebarFooterLinks[0].title =
          authUser.fullName !== '' ? authUser.fullName : authUser.userName;
        console.log('authUser.alreadyLoggedIn --> ' + authUser.alreadyLoggedIn);
        if (!authUser.alreadyLoggedIn) {
          if (this.dialog.openDialogs.length === 0) {
            this.dataService
              .getData('./assets/text/privacy.txt', true, true)
              .subscribe((data) => {
                if (data) {
                  // Incase can read -> Show policy popup
                  const dialogRef = this.dialog.open(
                    SystemPrivacyModalComponent,
                    {
                      width: '50%',
                      maxHeight: '660px'
                    }
                  );
                  dialogRef.componentInstance.privacyMessage = data;
                  dialogRef.afterClosed().subscribe((dialogData) => {
                    if (dialogData && dialogData.data) {
                      this.authService.takeOutFirstTimeOfUser().subscribe();
                      this.navigate();
                    }
                  });
                } else {
                  // Incase cannot read privacy file -> Navigate
                  this.navigate();
                }
              });
          }
        } else {
          // In case: not the first time user login
          this.navigate();
        }
      }
    });
  }

  navigate() {
    // Store time for checking inactive user
    localStorage.setItem('lastActivityTime', new Date().getTime().toString());
    localStorage.setItem('needForceLogout', 'false');
    //
    this.siteService.getSiteDetails().subscribe((sites) => {
      if (sites) {
        if (sites.length > 1) {
          this.router.navigate(['/site-master']);
          localStorage.setItem('isMultipleSites', 'true');
        } else if (sites.length === 1) {
          const find = this.auth.sidebarLinks.find(
            (c: any) => c.code === 'HOME'
          );
          if (!this.commonService.isNullOrUndefined(find)) {
            find.url = '/site';
            localStorage.setItem('siteId', sites[0].siteId);
            localStorage.setItem('isMultipleSites', 'false');
          }
          this.router.navigate(['/site'], {
            queryParams: { siteId: sites[0].siteId }
          });
        }
      }
    });
  }

  logout() {
    // this.adalService.logOut();
    this.oauthService.logOut();
    localStorage.removeItem('currentUser');
    localStorage.removeItem('access_token');
    this.sidebarService.setSidebarVisibility(false);
    this.router.navigate(['/']);
  }

  onAbout() {
    const dialogRef = this.dialog.open(BciImprintComponent, {
      width: '800px'
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }

  onPolicy() {
    this.dataService
      .getData('./assets/text/privacy.txt', true, true)
      .subscribe((data) => {
        if (data) {
          // Incase can read -> Show policy popup
          const dialogRef = this.dialog.open(SystemPrivacyModalComponent, {
            width: '50%',
            maxHeight: '660px'
          });
          dialogRef.componentInstance.firstLogin = true;
          dialogRef.componentInstance.privacyMessage = data;
          dialogRef.afterClosed().subscribe((result) => {});
        }
      });
  }

  onContact() {
    this.dataService
      .getData('./assets/text/contact.txt', true, true)
      .subscribe((data) => {
        if (data) {
          const dialogRef = this.dialog.open(ContactUsModalComponent, {
            width: '25%',
            maxHeight: '300px'
          });
          dialogRef.componentInstance.privacyMessage = data;
          dialogRef.afterClosed().subscribe((result) => {});
        }
      });
  }

  public redirectToDaimler() {
    this.logout();
  }
}
